"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.adminModerationContract = void 0;
const core_1 = require("@ts-rest/core");
const zod_1 = require("zod");
const utils_1 = require("../utils");
const models_1 = require("./models");
const c = (0, core_1.initContract)();
exports.adminModerationContract = c.router({
    getBlocklistEmail: {
        method: 'GET',
        path: '/get-blocklist-email',
        query: models_1.ZEmailBlocklistRequest,
        responses: {
            200: zod_1.z.object({
                isBlocked: zod_1.z.boolean(),
            }),
        },
        summary: 'Check if an email is blocklisted',
    },
    addEmailToBlocklist: {
        method: 'POST',
        path: '/add-email-to-blocklist',
        body: models_1.ZEmailBlocklistRequest,
        responses: {
            200: utils_1.successSchema,
        },
        summary: 'Add email to blocklist',
    },
    removeEmailFromBlocklist: {
        method: 'DELETE',
        path: '/remove-email-from-blocklist',
        body: models_1.ZEmailBlocklistRequest,
        responses: {
            200: utils_1.successSchema,
        },
        summary: 'Remove email from blocklist',
    },
}, {
    pathPrefix: '/admin',
    strictStatusCodes: true,
    baseHeaders: zod_1.z.object({
        'x-access-token': zod_1.z.string(),
    }),
    commonResponses: {
        401: c.type(),
        403: c.type(),
    },
});
//# sourceMappingURL=moderation.admin.contract.js.map